export const workExperience = [
  {
    id: 'magic-hour-ai',
    company: 'Magic Hour AI',
    role: 'Software Engineering Intern',
    location: 'San Francisco, California',
    dates: 'September 2026 – Present',
    logo: '/magichourai.jpg',
    logoFit: 'cover',
    url: 'https://magichour.ai/',
  },
  {
    id: 'hermesai',
    company: 'HermesAI',
    role: 'Software Engineering Intern',
    location: 'Toronto, Ontario',
    dates: 'May 2026 – August 2026',
    logo: '/hermesailogo.jpg',
    logoTheme: 'light',
    logoFit: 'contain',
    url: 'https://hermesai.ca/',
  },
  {
    id: 'mcmaster-mars-rover',
    company: 'McMaster Mars Rover Team',
    role: 'Software Engineer',
    location: 'Hamilton, Ontario',
    dates: 'September 2026 – Present',
    logo: '/mmrt-logo.png',
    logoTheme: 'light',
    logoFit: 'contain',
    logoScale: 1.2,
    logoPadding: 0,
    url: 'https://www.mcmastermarsrover.com/',
  },
  {
    id: 'McMaster Drone',
    company: 'McMaster Aerial Drone and Robotics Team',
    role: 'Software Engineer',
    location: 'Hamilton, Ontario',
    dates: 'June 2026 - Present',
    logo: '/Droneteam.png',
    logoTheme: 'light',
    logoFit: 'contain',
    logoScale: 1.25,
    logoPadding: 0,
    logoOffsetY: '3px',
    url: 'https://www.macdrones.ca/',
  },
];
